export default __webpack_public_path__ + "assets/img/juara1.4adf6f7471bef456bef6d79b2b2e690f.png";